
<template>
  <div id="header"
    :class="{ dark }">
    <div class="head back"></div>
    <div class="head">
      <div class="logo-wrap"
        @click="gotoHome">
        <img class="front"
          src="/images/logo_header_light.png" alt="">
        <img class="end"
          src="/images/logo_header.png" alt="">
      </div>
      <div class="nav">
        <!-- <router-link to="/">Home</router-link> -->
        <router-link to="/about" >
          <Navlink :text="$t('nav.about')"
            :menu="false"
            :dark="dark"
            :border="false" />
        </router-link>
        <router-link to="/productgroups" >
          <Navlink :text="$t('nav.products')"
            :menu="false"
            :dark="dark"
            :border="false" />
        </router-link>
        <router-link :to="'/medias/' + $t('mediasLinkNum')" >
          <Navlink :text="$t('nav.medias')"
            :menu="false"
            :dark="dark"
            :border="false" />
        </router-link>
        <router-link to="/contact" >
          <Navlink :text="$t('nav.contact')"
            :menu="false"
            :dark="dark"
            :border="false" />
        </router-link>

        <div class="menu-btn-wrap">
          <div class="back-menu"
            :class="{ active }"
            @click.stop="triggerBtn1"
            style="display: none;">
            <div class="back-menu-content">
              <div class="left">
                <div class="fade link" data-to="/about"
                  @click.stop="closeBtn('/about')">
                  <Navlink :text="$t('nav.about')"
                    :dark="false"
                    :border="false" />
                </div>
                <div class="fade link" data-to="/productgroups"
                  @click.stop="closeBtn('/productgroups')">
                  <Navlink :text="$t('nav.products')"
                    :dark="false"
                    :border="false" />
                </div>
                <div class="fade link" data-to="/base"
                  @click.stop="closeBtn('/base')">
                  <Navlink :text="$t('nav.base')"
                    :dark="false"
                    :border="false" />
                </div>
                <div class="fade link" :data-to="'/medias/' + $t('mediasLinkNum')"
                  @click.stop="closeBtn('/medias/' + $t('mediasLinkNum'))">
                  <Navlink :text="$t('nav.medias')"
                    :dark="false"
                    :border="false" />
                </div>
                <div class="fade link" data-to="/human"
                  @click.stop="closeBtn('/human')">
                  <Navlink :text="$t('nav.human')"
                    :dark="false"
                    :border="false" />
                </div>
                <div class="fade link" data-to="/contact"
                  @click.stop="closeBtn('/contact')">
                  <Navlink :text="$t('nav.contact')"
                    :dark="false"
                    :border="false" />
                </div>
              </div>
              <div class="right ft-20">
                <div class="fade row tel">0086-574-88847563</div>
                <div class="fade row fax">0086-574-88845098</div>
                <div class="fade row mail">todayfood@todayfood.com.cn</div>
              </div>
            </div>
          </div>

          <div class="menu-btn"
            :class="{ active }"
            @click.stop="triggerBtn1">
            <div class="menu-burger-wrapper">
              <div class="trigger menu-trigger">
                <div class="menu-burger icon-wrapper">
                  <div class="line line-top"></div>
                  <div class="line line-center"></div>
                  <div class="line line-bottom"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <LangBox ref="langbox" />
  </div>
</template>

<script>
import Navlink from '@/components/Navlink.vue'
import LangBox from '@/components/LangBox.vue'
import scroll from '@/oceanSchool/scroll.js'
import { TimelineLite, Power2 } from 'gsap/TweenMax'
import { qs, qsa } from '@/util/dom.js'

export default {
  components: {
    Navlink,
    LangBox
  },

  data () {
    return {
      dark: false,
      active: false
    }
  },

  beforeDestroy () {
    scroll.unbind('header-dark')
  },

  mounted () {
    this.animating = false
    this.$nextTick(() => {
      scroll.bind('header-dark', this.scrollHeaderDark)
    })
  },

  methods: {
    scrollHeaderDark () {
      if (window.currentScrollTop > 0) {
        this.dark = true
        return
      }

      this.dark = false
    },

    triggerBtn1 () {
      const onComplete = () => {
        this.animating = false
      }
      const el = qs('.back-menu', this.$el)
      const elfade = qsa('.fade', this.$el)
      const tl = new TimelineLite()

      if (this.animating) return
      this.animating = true

      if (this.active) {
        tl.staggerFromTo(
          elfade,
          0.8,
          {
            opacity: 1,
            transform: 'translateY(0)'
          },
          {
            opacity: 0,
            transform: 'translateY(-400px)',
            ease: Power2.easeOut
          },
          0.1
        ).to(el, 0.4, {
          opacity: 0,
          display: 'none',
          ease: Power2.easeOut
        }).set(el, {
          left: '100%',
          onComplete
        })
      } else {
        tl.set(el, {
          left: 0
        }).to(el, 0.4, {
          opacity: 1,
          display: 'flex',
          ease: Power2.easeOut
          // onComplete
        }).staggerFromTo(
          elfade,
          0.8,
          {
            opacity: 0,
            transform: 'translateY(400px)'
          },
          {
            opacity: 1,
            transform: 'translateY(0)',
            ease: Power2.easeOut
          },
          0.1,
          '-=0.4',
          onComplete
        )
      }

      this.active = !this.active
    },

    closeBtn (url) {
      const onComplete = () => {
        this.animating = false
      }
      const el = qs('.back-menu', this.$el)
      const elfade = qsa('.fade', this.$el)
      const tl = new TimelineLite()

      if (this.animating) return
      this.animating = true

      tl.staggerFromTo(
        elfade,
        0.8,
        {
          opacity: 1,
          transform: 'translateY(0)'
        },
        {
          opacity: 0,
          transform: 'translateY(-400px)',
          ease: Power2.easeOut
        },
        0.1
      ).to(el, 0.4, {
        opacity: 0,
        ease: Power2.easeOut
      }).set(el, {
        left: '100%',
        onComplete
      })

      this.active = false
      this.$router.push(url)
    },

    gotoHome () {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="scss" scoped>
.fade.link {
  cursor: pointer;
}

#header {
  position: fixed;
  width: 100%;
  z-index: 2000;
}

.head {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.head.back {
  background-color: rgba(255, 255, 255, 0.94);
  height: 0;
  transition: height 0.8s ease-in-out;
}
.dark .head.back {
  height: 100px;
}

img.front {
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
}
img.end {
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
}
.dark img.front {
  opacity: 0;
}
.dark img.end {
  opacity: 1;
}

.logo-wrap {
  cursor: pointer;
  width: 281px;
  height: 65px;;
  margin-left: 60px;

  img {
    position: absolute;
  }
}

.nav {
  display: flex;
  height: 100px;
  align-items: center;
}

// .nav a {
//   color: #fff;
//   width: 170px;
//   height: 60px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   font-size: 16px;

//   // &.router-link-exact-active {
//   //   border: 1px solid #fff;
//   // }

//   &.border {
//     border: 1px solid #fff;
//   }
// }

.menu-btn-wrap {
  width: 160px;
  padding-left: 50px;
}

.menu-btn {
  // z-index: 1050;
  // position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  // border-width: 1px;
  // border-style: solid;
  // border-radius: 25px;
  // border-color: #fff;
  // transition: border-color 0.8s;
  // transition-delay: 0s;
  cursor: pointer;

  .menu-burger-wrapper {
    width: 20px;
    height: 20px;

    .menu-trigger {
      position: relative;
      width: 100%;
      height: 100%;

      .menu-burger {
        width: 100%;
        height: 100%;
        position: relative;
        transition: transform 0.4s;

        .line {
          background-color: #fff;
          position: absolute;
          left: 0;
          width: 100%;
          height: 1px;
          transform-origin: 50% 50%;
          transition: transform 0.5s 0.08s,background-color 0.8s,top 0.5s 0.08s,left 0.3s,opacity 0.5s,width 0.6s 0.05s;
        }
        .line-top {
          top: 0;
        }
        .line-center {
          top: 50%;
          width: 75%;
        }
        .line-bottom {
          top: 100%;
        }
      }
    }
  }
}

.menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger {
  transform: rotate(90deg);
}

.menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger .line-top {
  top: 50%;
  transform: rotate(45deg) translate(0, -50%);
}
.menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger .line-center {
  opacity: 0;
  left: -5px;
  width: 0;
}
.menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger .line-bottom {
  top: 50%;
  transform: rotate(-45deg) translate(0, -50%);
  width: 100%;
}

.menu-btn:hover .menu-burger-wrapper .menu-trigger .menu-burger .line-center {
  width: 100%;
}

.dark .menu-btn:not(.active) .menu-burger-wrapper .menu-trigger .menu-burger .line {
  background-color: #000;
}

.back-menu {
  position: fixed;
  top: 0;
  left: 100%;
  bottom: 0;
  right: 0;
  opacity: 0;
  background-color: rgba(3, 25, 47, 0.94); // #03192f;
  // z-index: 2100;
  display: flex;
  justify-content: center;
  align-items: center;
}

.back-menu-content {
  display: flex;
  max-width: 600px;
  width: 100%;
  margin: 30px;
  justify-content: space-between;

  // .left {
  //   .router-link-exact-active {
  //     color: #8fd6ed;
  //   }
  // }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;

    .row {
      height: 60px;
      display: flex;
      align-items: center;
    }
    .tel:before {
      content: "";
      background-image: url(/images/icon-tel.png);
      width: 24px;
      height: 26px;
      margin-right: 16px;
    }
    .fax:before {
      content: "";
      background-image: url(/images/icon-fax.png);
      width: 21px;
      height: 20px;
      margin-right: 16px;
    }
    .mail:before {
      content: "";
      background-image: url(/images/icon-mail.png);
      width: 24px;
      height: 18px;
      margin-right: 16px;
    }
  }
}
@media(max-width: 768px){
  .head{
    display: flex;
    justify-content: space-between;
    .logo-wrap{
      margin-left: 0;
    }
    .nav{
      &>a{
        display: none;
      }
      .menu-btn-wrap{
        width: auto;
        padding-left: 0;
      }
    }
    .back-menu-content{
      justify-content: center;
      .right{
        display: none;
      }
    }
  }
}
</style>
